import React, { Component, useState, useEffect } from 'react'
import Header from '../Header';
import Menu from '../Menu';
import 'jquery/dist/jquery.min.js';
// //Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"
// import "datatables.net-dt/css/jquery.dataTables.min.css"
import $ from 'jquery';
import axios from 'axios';
import Modal from 'react-modal';
import CollegeList from './CollegeList';

const customStyles = {
    content: {
        top: '55%',
        left: '50%',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: '5px solid #007bff',
        width: '60%',
        height: '90%',
        margin: 'auto',
        overflow: 'scroll',
    },
};

function AllotmentDetails() {
    const [data, setState] = useState()
    const [college, setCollege] = useState([])
    const [studentId, setStudentId] = useState(null);
 // modal action
    let subtitle;
    const [modalIsOpen, setIsOpen] = React.useState(false);

   
    function openModal() {
        setIsOpen(true);
    }

    function afterOpenModal() {
        // references are now sync'd and can be accessed.
        subtitle.style.color = '#f00';
    }

    function closeModal() {
        setIsOpen(false);
    }

    const removeStudentFromList = async(id)=>{
       await fetchData()
    }
    // State array variable to save and show data
    const fetchData = () => {
        axios.get('/counselling/student-allotment-details').then(res => {
            //Storing users detail in state array object
            setState(res.data.data);

            // console.log("dataAPI", res.data.userList);

        });
        $(document).ready(function () {
            setTimeout(function () {
                $('#example').DataTable(
                    {
                        pagingType: 'full_numbers',
                        pageLength: 15,
                        processing: true,
                        dom: 'Bfrtip',
                        buttons: ['copy', 'csv', 'print', 'excelHtml5', 'pdf'
                        ]
                    }
                );
            },
                2000
            );
        });
    }

     const onClick = (college, _id) => {
        setCollege(college)
        setStudentId(_id)
        setIsOpen(true)
    }
    useEffect(() => {
        fetchData()
    }, [])
    return (
        <div>
            <Header />
            <Menu />
            <div className="content-wrapper">
                <div className="container p-5">
                    <table id="example" class="table table-hover table-bordered">
                        <thead>
                            <tr>
                                <th>Sl.No</th>
                               
                                <th>Student Name</th>
                                <th>Father's Name</th>
                                <th>Mobile No</th>
                                <th>Email-ID</th>
                                <th>State</th>
                              
                                <th>Program</th>
                                <th>Round One</th>
                                <th>Round Two</th>
                                <th>Round Three</th>

                                <th>View College</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data && data.map((result, slNo) => {
            return (
                <>
                <tr>
                            <td>{slNo+1}</td>
                               
                                <td>{result.user.name}</td>
                                <td>{result.personal_details[0].fatherName} </td>
                                <td>{result.user.mobileNo}</td>
                                <td>{result.user.email}</td>
                                <td>{result.personal_details[0].state} </td>
                               
                                <td>{result.examination_marks[0].prog_opted}</td>
                                <td>
                                    {result.round_one_alloted_college ? JSON.stringify(result.round_one_alloted_college) : 'Not Alloted'}
                                </td>
                                <td>
                                    {result.round_two_alloted_college ? JSON.stringify(result.round_two_alloted_college) : 'Not Alloted'}
                                </td>
                                <td>
                                    {result.round_three_alloted_college ? JSON.stringify(result.round_three_alloted_college) : 'Not Alloted'}
                                </td>

                                <td><button onClick={() => { onClick(result.college, result._id) }} style={{backgroundColor:'#007bff',color:'white',borderRadius:'20%',border:'#007bff'}}>View</button></td>
                        </tr>
                </>

            )
        })}
                        </tbody>
                    </table>

                </div>

            </div>

             <div>
                            <button onClick={openModal}>Open Modal</button>
                            <Modal
                                isOpen={modalIsOpen}
                                onAfterOpen={afterOpenModal}
                                onRequestClose={closeModal}
                                style={customStyles}
            
                                contentLabel="Example Modal"
                            >
                                <h2 ref={(_subtitle) => (subtitle = _subtitle)} style={{ color: '#007bff', fontWeight: 'bold' }}>List of Colleges</h2>
                                <CollegeList college={college} studentId={studentId} fetchData={removeStudentFromList} setIsOpen={setIsOpen} round="one" isView={false} />
                            </Modal>
                        </div>
        </div>
    )
}

export default AllotmentDetails
